var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJoystick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 70,
    viewBox: "0 0 86 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3415_16357)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3415_16357",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 4,
    width: 62,
    height: 62
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 62,
    height: 62,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3415_16357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2065 55.6667C21.6232 55.6667 19.4166 54.741 17.5867 52.8896C15.7569 51.0382 14.7989 48.7993 14.7128 46.173C14.7128 45.7855 14.7343 45.398 14.7774 45.0105C14.8204 44.623 14.885 44.2355 14.9711 43.848L20.3961 22.148C20.9989 19.823 22.226 17.9393 24.0774 16.4969C25.9287 15.0546 28.0385 14.3334 30.4065 14.3334H55.594C57.9621 14.3334 60.0718 15.0546 61.9232 16.4969C63.7746 17.9393 65.0017 19.823 65.6044 22.148L71.0294 43.848C71.1156 44.2355 71.1909 44.6337 71.2555 45.0428C71.3201 45.4518 71.3524 45.85 71.3524 46.2375C71.3524 48.8639 70.4159 51.0921 68.543 52.9219C66.6701 54.7518 64.4204 55.6667 61.794 55.6667C59.9857 55.6667 58.3065 55.1931 56.7565 54.2459C55.2065 53.2987 54.044 52.007 53.269 50.3709L51.4607 46.625C51.2454 46.1945 50.9225 45.8716 50.4919 45.6563C50.0614 45.441 49.6093 45.3334 49.1357 45.3334H36.8649C36.3912 45.3334 35.9392 45.441 35.5086 45.6563C35.0781 45.8716 34.7551 46.1945 34.5399 46.625L32.7315 50.3709C31.9565 52.007 30.794 53.2987 29.244 54.2459C27.694 55.1931 26.0149 55.6667 24.2065 55.6667ZM46.8753 32.4167C47.6072 32.4167 48.2208 32.1691 48.7159 31.674C49.211 31.1789 49.4586 30.5653 49.4586 29.8334C49.4586 29.1014 49.211 28.4879 48.7159 27.9927C48.2208 27.4976 47.6072 27.25 46.8753 27.25C46.1433 27.25 45.5298 27.4976 45.0346 27.9927C44.5395 28.4879 44.2919 29.1014 44.2919 29.8334C44.2919 30.5653 44.5395 31.1789 45.0346 31.674C45.5298 32.1691 46.1433 32.4167 46.8753 32.4167ZM52.0419 27.25C52.7739 27.25 53.3874 27.0025 53.8826 26.5073C54.3777 26.0122 54.6253 25.3987 54.6253 24.6667C54.6253 23.9348 54.3777 23.3212 53.8826 22.8261C53.3874 22.3309 52.7739 22.0834 52.0419 22.0834C51.31 22.0834 50.6965 22.3309 50.2013 22.8261C49.7062 23.3212 49.4586 23.9348 49.4586 24.6667C49.4586 25.3987 49.7062 26.0122 50.2013 26.5073C50.6965 27.0025 51.31 27.25 52.0419 27.25ZM52.0419 37.5834C52.7739 37.5834 53.3874 37.3358 53.8826 36.8407C54.3777 36.3455 54.6253 35.732 54.6253 35C54.6253 34.2681 54.3777 33.6546 53.8826 33.1594C53.3874 32.6643 52.7739 32.4167 52.0419 32.4167C51.31 32.4167 50.6965 32.6643 50.2013 33.1594C49.7062 33.6546 49.4586 34.2681 49.4586 35C49.4586 35.732 49.7062 36.3455 50.2013 36.8407C50.6965 37.3358 51.31 37.5834 52.0419 37.5834ZM57.2086 32.4167C57.9406 32.4167 58.5541 32.1691 59.0492 31.674C59.5444 31.1789 59.7919 30.5653 59.7919 29.8334C59.7919 29.1014 59.5444 28.4879 59.0492 27.9927C58.5541 27.4976 57.9406 27.25 57.2086 27.25C56.4767 27.25 55.8631 27.4976 55.368 27.9927C54.8728 28.4879 54.6253 29.1014 54.6253 29.8334C54.6253 30.5653 54.8728 31.1789 55.368 31.674C55.8631 32.1691 56.4767 32.4167 57.2086 32.4167ZM33.9586 36.2917C34.5183 36.2917 34.9812 36.1087 35.3471 35.7428C35.7131 35.3768 35.8961 34.9139 35.8961 34.3542V31.7709H38.4794C39.0392 31.7709 39.502 31.5879 39.868 31.2219C40.234 30.8559 40.4169 30.3931 40.4169 29.8334C40.4169 29.2737 40.234 28.8108 39.868 28.4448C39.502 28.0789 39.0392 27.8959 38.4794 27.8959H35.8961V25.3125C35.8961 24.7528 35.7131 24.29 35.3471 23.924C34.9812 23.558 34.5183 23.375 33.9586 23.375C33.3989 23.375 32.936 23.558 32.5701 23.924C32.2041 24.29 32.0211 24.7528 32.0211 25.3125V27.8959H29.4378C28.878 27.8959 28.4152 28.0789 28.0492 28.4448C27.6833 28.8108 27.5003 29.2737 27.5003 29.8334C27.5003 30.3931 27.6833 30.8559 28.0492 31.2219C28.4152 31.5879 28.878 31.7709 29.4378 31.7709H32.0211V34.3542C32.0211 34.9139 32.2041 35.3768 32.5701 35.7428C32.936 36.1087 33.3989 36.2917 33.9586 36.2917Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3415_16357",
    x: 0.712769,
    y: 0.333374,
    width: 84.6396,
    height: 69.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.490196 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3415_16357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3415_16357",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoystick);
export default __webpack_public_path__ + "static/media/joystick.4fe56e53bf7a74db33ef78803674d436.svg";
export { ForwardRef as ReactComponent };